<template>
  <div class="out">
    <span class="users">{{ username }}</span>
    <el-dropdown>
      <span class="el-dropdown-link avatarbox">
        <!-- 下拉菜单<i class='el-icon-arrow-down el-icon--right'></i> -->
        <!-- @error='' -->
        <el-avatar size="medium" :src="squareUrl">
          <img src="@/assets/headers.gif" alt="头像" />
        </el-avatar>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item disabled>个人信息</el-dropdown-item>
        <el-dropdown-item disabled>权限信息</el-dropdown-item>
        <el-dropdown-item disabled>设置</el-dropdown-item>
        <el-dropdown-item @click.native="loginOut" divided
          >退出</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { LoginOut } from "api/post/postApi.js";
export default {
  name: "comm_out",
  data() {
    return {
      squareUrl: "",
      username: "",
    };
  },
  created() {
    this.username = window.sessionStorage.getItem("username");
  },
  methods: {
    // 退出功能
    async loginOut() {
      const { data: res } = await LoginOut();
      if (res.status !== 0) {
        this.$message.error("退出失败！");
      } else {
        this.$message.success("退出成功！");
        window.sessionStorage.removeItem("Authorization");
        window.sessionStorage.removeItem("activeItem");
        window.sessionStorage.removeItem("path");
        this.removeCookie("isLogin");
        this.removeCookie("userName");
        this.removeCookie("role");
        this.removeCookie("LoginName");
        window.location.href = "https://www.singera.cn/#/login";
        // window.location.href = "https://t.singera.cn/#/login";
      }

      // this.$router.push({ path:'/login' });
    },
    setCookie(key, value, t) {
      var oDate = new Date();
      oDate.setDate(oDate.getDate() + t);
      let domain = ';domain=.singera.cn;path=/';
      document.cookie = key + "=" + value + "; expires=" + oDate.toDateString() + domain;
    },
    removeCookie(key) {
      this.setCookie(key, "", -1); //把cookie设置为过期
    },
  },
};
</script>

<style scoped>
.users {
  font-size: 14px;
  margin-right: 5px;
}
</style>